// QUICKVIEW Modal
document.addEventListener('DOMContentLoaded', function () {
    const quickViewModalEl = document.getElementById('quickViewModal');
    const qVmodal = bootstrap.Modal.getInstance(quickViewModalEl) || new bootstrap.Modal(quickViewModalEl);
    const modalContentArea = document.getElementById('js-modal-content');
    let coBrandProductID;

    // Helper to strip query/hash from URLs for structured data
    function cleanUrl(raw) {
        try { const u = new URL(raw, window.location.origin); u.search = ''; u.hash = ''; return u.toString(); } catch { return raw.split('?')[0]; }
    }

    // Ensure Algolia Insights is initialized once, whenever `window.aa` becomes available.
    // Works whether Insights is injected by InstantSearch or loaded manually elsewhere.
    function ensureInsightsInit() {
        // If Insights isn't present yet, bail (we'll try again later)
        if (typeof window.aa !== 'function') return false;

        // If already initialized, don't do it again
        if (window.__algoliaInsightsInited) return true;

        window.aa('init', {
            appId: window.algoliaConfig.appId,
            apiKey: window.algoliaConfig.searchKey,
            useCookie: true,
        });

        window.__algoliaInsightsInited = true;
        return true;
    }
    
    
    // Algolia Ctx
    let algoliaCtx = null; // { index, objectID, queryID }

    // IMPORTANT: attach the delegated click handler ONCE (works with dynamic injected HTML)
    // It listens for clicks anywhere inside modalContentArea, then checks if the click
    // was on (or inside) the Product Details link.
    modalContentArea.addEventListener('click', (e) => {
        const qvDetailsLink = e.target.closest('#js-qvProductDetails');
        if (!qvDetailsLink) return;

        // Store attribution so the Product Details page can send Add-To-Cart conversion
        // (This works even if the product page itself is NOT an InstantSearch page.)
        try {
            sessionStorage.setItem('algolia_attrib', JSON.stringify({
                index: algoliaCtx?.index || null,
                objectID: algoliaCtx?.objectID || null,
                queryID: algoliaCtx?.queryID || '',
                position: algoliaCtx?.position ?? null,
                source: 'quickview' // optional: helps debugging
            }));
        } catch {
            // ignore storage errors (Safari private mode etc)
        }

        // Make sure Insights is initialized (no-op if already done)
        if (!ensureInsightsInit()) return;
        
        
        
        // If this modal is used on a non-Algolia page, aa won't exist
        if (typeof window.aa !== 'function') return;

        if (!algoliaCtx?.index || !algoliaCtx?.objectID) return;

        // // SAME click event type, DIFFERENT event name
        if (algoliaCtx.queryID && Number.isFinite(algoliaCtx.position)) {
            window.aa('clickedObjectIDsAfterSearch', {
                eventName: 'QV Product Details',
                index: algoliaCtx.index,
                objectIDs: [algoliaCtx.objectID],
                queryID: algoliaCtx.queryID,
                positions: [algoliaCtx.position],
                url: cleanUrl(window.location.href)
            });
        } else {
            // fallback (no queryID or position available)
            window.aa('clickedObjectIDs', {
                eventName: 'QV Product Details',
                index: algoliaCtx.index,
                objectIDs: [algoliaCtx.objectID],
                url: cleanUrl(window.location.href)
            });
        }
    });
    
    
    // store the Flickity instances here
    let flickityInstances = null;

    // function to initialize Flickity
    function initializeFlickity() {
        const flktyNav = new Flickity(".js-carousel-nav", {
            asNavFor: ".js-carousel-product",
            contain: true,
            pageDots: false,
            lazyLoad: 5,
            selectedAttraction: 0.2,
            prevNextButtons: false,
            friction: 0.8,
            draggable: true,
        });

        const flktyProduct = new Flickity(".js-carousel-product", {
            pageDots: false,
            lazyLoad: true,
            fullscreen: false,
            selectedAttraction: 0.2,
            friction: 0.8,
        });

        // make Flickity instances visible
        setContainerVisibility(".js-carousel-product", "visible");
        setContainerVisibility(".js-carousel-nav", "visible");

        // update alt tags to improve accessibility
        updateImageAlts(".js-carousel-product", "Product Photo");
        updateImageAlts(".js-carousel-nav", "Thumbnail Photo");

        return { flktyNav, flktyProduct };
    }

    // Function to destroy Flickity
    function destroyFlickity() {
        if (flickityInstances) {
            flickityInstances.flktyNav.destroy();
            flickityInstances.flktyProduct.destroy();

            // set ProductCarousel container visibility back to 'hidden'
            setContainerVisibility(".js-carousel-product", "hidden");

            // set NavCarouselcontainer container visibility back to 'hidden'
            setContainerVisibility(".js-carousel-nav", "hidden");

            // set to null to avoid using destroyed instances
            flickityInstances = null;
        }
    }

    // update image alt tags
    function updateImageAlts(containerSelector, prefix) {
        const container = document.querySelector(containerSelector);
        if (container) {
            const images = container.querySelectorAll("img");
            images.forEach((img, index) => {
                img.alt = `${prefix} ${index + 1} ${img.alt}`;
            });
        }
    }

    // Function to resize Flickity
    function resizeFlickity() {
        if (flickityInstances) {
            flickityInstances.flktyNav.resize();
            flickityInstances.flktyProduct.resize();
        }
    }

    // set flickity visibility to avoid FOOC
    function setContainerVisibility(selector, visibility) {
        const container = document.querySelector(selector);
        if (container) {
            container.style.visibility = visibility;
        }
    }

    document.body.addEventListener('click', async (event) => {
        const openBtn = event.target.closest('.js-open-quickview-modal');
        if (!openBtn) return;

        // Check if modal is open
        if (quickViewModalEl.classList.contains('show')) {
            qVmodal.hide();
        }

        // Get the product id from the button
        coBrandProductID = openBtn.getAttribute('data-prodId');

        // Capture Algolia ctx from the button (safe if attributes don't exist)
        algoliaCtx = {
            index: openBtn.getAttribute('data-algolia-index'),
            objectID: openBtn.getAttribute('data-algolia-objectid'),
            queryID: openBtn.getAttribute('data-algolia-queryid'),
            position: parseInt(openBtn.getAttribute('data-algolia-position') || '', 10),
        };

        // Remove old content from modal
        modalContentArea.innerHTML = "";

        // Get content for modal
        try {
            const response = await fetch(`/preview/${coBrandProductID}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.text();
            modalContentArea.innerHTML = data;
            
            // Try to init insights now that the page is interactive
            ensureInsightsInit();

            // Show quickview modal
            qVmodal.show();

            // Initialize Flickity after the modal is shown
            quickViewModalEl.addEventListener(
                'shown.bs.modal',
                function () {
                    destroyFlickity();
                    flickityInstances = initializeFlickity();
                },
                { once: true }
            );

            // ADD TO ANY after quickview initialization
            if (typeof a2a !== 'undefined' && a2a) {
                a2a.init_all();
            }
        } catch (error) {
            console.error('Error calling API:', error);
        }
    });

    // Listen to when quickview modal closes
    quickViewModalEl.addEventListener('hidden.bs.modal', function () {
        destroyFlickity();
    });

    // Share button in quickview modal
    quickViewModal.addEventListener('click', async (e) => {
        const btn = e.target.closest('#js-qvSampleButton');
        if (btn) {
            const cbpid = coBrandProductID
                ? coBrandProductID
                : "";
            const url = '/api/samplebasket/add/' + cbpid;
            const response = await fetch(url, {
                method: 'POST'
            });
            if (response.ok) {
                const count = await response.text();
                const countText = count > 0 ? '(' + count + ')' : '';
                document.querySelectorAll('.js-sampleBasketCount')
                    .forEach(el => el.textContent = countText);
            }
            const qvModalAlert = document.getElementById('js-quickview-alert');
            const qvModalAlertText = document.getElementById('js-alert-message-note');

            // Show alert
            qvModalAlertText.innerHTML = "<p><strong>PRODUCT ADDED:</strong> This product has been added into your sample basket. When you have finished requesting all of your samples, click on Sample Basket to finalize your request.</p>"
            qvModalAlert.classList.remove('d-none');
            // trigger fade-in
            qvModalAlert.classList.add('show');
            setTimeout(() => {
                qvModalAlert.classList.remove('show');   // fades out
                setTimeout(() => qvModalAlert.classList.add('d-none'), 150);
                // add d-none after fade completes (Bootstrap fade = 150ms)
            }, 5000);
        }
    });
});